import { BasicInformation, ProfileImage } from 'components/Dashboard/StakeHolders/StakeholderPage/ui/BioElements';
import { useRef, useState } from 'react';
import { useCollapse } from 'react-collapsed';
import { Link } from 'react-router-dom';

const EmployersElement = (props) => {
  const { employers, activityContainer } = props;
  return (
    <div className='d-flex flex-column'>
      {employers?.map((item) => {
        const { id } = item;
        return (
          <Employer
            key={`employer-item-${id}`}
            employer={item}
            isMultiple={employers?.length > 1}
            activityContainer={activityContainer}
          />
        );
      })}
    </div>
  );
};

const Employer = (props) => {
  const { employer, isMultiple, activityContainer } = props;
  const { canonicalUrl } = employer;

  const [isExpanded, setIsExpanded] = useState(false);
  const containerElement = useRef(null);
  const { getCollapseProps, getToggleProps } = useCollapse({
    isExpanded,
    onTransitionStateChange: (state) => {
      if (state !== 'expandEnd') return;

      const el = containerElement.current;
      const container = activityContainer?.current?.view;
      if (!el || !container) return;

      const elRect = el.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();

      const offsetTop = elRect.top - containerRect.top;
      const offsetBottom = offsetTop + el.offsetHeight;

      if (offsetBottom > container.clientHeight) {
        container.scrollTo({
          top: container.scrollTop + (offsetBottom - container.clientHeight) + 24,
          behavior: 'smooth',
        });
      }
    },
  });

  return (
    <div
      className={`border rounded-top bg-main-white mb-4 ${isMultiple ? `employer-dropdown-element ${isExpanded ? 'open' : ''}` : ''}`}
      ref={containerElement}
    >
      <div
        {...(isMultiple
          ? getToggleProps({
              onClick: () => setIsExpanded((prevExpanded) => !prevExpanded),
            })
          : {})}
      >
        <ProfileImage StakeholderInformation={employer} />
      </div>

      <div {...(isMultiple ? getCollapseProps() : {})}>
        <div className='px-4 py-3'>
          <Link
            to={canonicalUrl}
            className='d-inline-block reset-link text-main-white action-button px-4 rounded-pill specific-y-padding-5 specific-top-margin-8 specific-bottom-margin-1'
          >
            Go to profile
          </Link>
          <div className='pt-4'>
            <BasicInformation StakeholderInformation={employer} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployersElement;
